/**
 * EditorAnalytics - Event tracking for editor operations
 *
 * Key features:
 * - EditorEvents enum for event types
 * - trackEditorEvent() function
 * - Console logging for Phase 1 (Ahoy integration deferred)
 *
 * Implementation: Task 8.0
 */

// ADDED: Event types enum
export const EditorEvents = {
  // Save events
  SAVE_STARTED: 'editor.save.started',
  SAVE_SUCCEEDED: 'editor.save.succeeded',
  SAVE_FAILED: 'editor.save.failed',
  SAVE_RETRIED: 'editor.save.retried',

  // Draft events
  DRAFT_SAVED: 'editor.draft.saved',
  DRAFT_RECOVERED: 'editor.draft.recovered',
  DRAFT_DISCARDED: 'editor.draft.discarded',

  // Connection events
  CONNECTION_LOST: 'editor.connection.lost',
  CONNECTION_RESTORED: 'editor.connection.restored',
  AUTH_EXPIRED: 'editor.auth.expired',

  // Conflict events
  CONFLICT_DETECTED: 'editor.conflict.detected',
  CONFLICT_RESOLVED_KEEP_MINE: 'editor.conflict.resolved.keep_mine',
  CONFLICT_RESOLVED_USE_THEIRS: 'editor.conflict.resolved.use_theirs',
  CONFLICT_TIMED_OUT: 'editor.conflict.timed_out' // Phase 10: Conflict modal auto-dismissed
}

// ADDED: Track editor event - console logging for Phase 1
export function trackEditorEvent(event, properties = {}) {
  const payload = {
    event,
    properties: {
      ...properties,
      timestamp: new Date().toISOString()
    }
  }

  // Phase 1: Console logging only
  // Phase 1b: Integrate with Ahoy tracking
  console.log('[EditorAnalytics]', event, payload.properties)
}
